import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue'
import { ElMessage } from 'element-plus'
import { removeComment } from '@/features/FRemoveComment/api/remove.api'
import { showErrorMessage } from '@/shared/utils'
import { ReportViewType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  commentId: Number,
  reportType: String as PropType<ReportViewType>,
},
  emits: ['update'],
  setup(__props, { emit }) {

const props = __props





const handleRemoveComment = async (): Promise<void> => {
  const [error] = await removeComment(props.reportType, props.commentId)

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Комментарий удален',
      type: 'success',
    })

    emit('update')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "remove-comment",
    type: "button",
    onClick: handleRemoveComment
  }, " Удалить "))
}
}

})